import React from "react";
import PageHeader from "@/components/PageHeader";
import WhyChoose from "@/components/WhyChoose";
import TrustCounters from "@/components/TrustCounters";
import Testimonials from "@/components/Testimonials";
import CtaBanner from "@/components/CtaBanner";
import { useLayout } from "@/components/Layout";

export default function AboutPage() {
  const { openPlan } = useLayout();
  return (
    <div data-testid="about-page">
      <PageHeader
        overline="About Travwave"
        title={"A travel atelier,\nnot a booking engine."}
        subtitle="Founded in 2014, Travwave is a small, devoted team of consultants who only design journeys worth talking about for years. We travel first. We plan second."
        image="https://images.unsplash.com/photo-1519681393784-d120267933ba?q=80&w=2000&auto=format&fit=crop"
      />

      <TrustCounters />

      <section className="py-24 md:py-32 px-6 lg:px-10">
        <div className="max-w-7xl mx-auto grid lg:grid-cols-2 gap-16 items-center">
          <div className="rounded-3xl overflow-hidden aspect-[4/5] lg:aspect-[3/4]">
            <img
              src="https://images.unsplash.com/photo-1522202176988-66273c2fd55f?q=80&w=1600&auto=format&fit=crop"
              alt="Travwave consultants"
              className="w-full h-full object-cover"
              loading="lazy"
            />
          </div>
          <div>
            <div className="overline">Our Story</div>
            <h2 className="font-display text-4xl md:text-5xl text-[#0A2342] leading-[1.05] mt-3">
              We measure success in stories, not bookings.
            </h2>
            <div className="mt-8 space-y-5 text-[#6B7280] text-lg leading-relaxed">
              <p>
                Travwave was born from a quiet frustration — that luxury travel had become transactional. Cookie-cutter packages. Impersonal chat bots. Hotels sold like commodities.
              </p>
              <p>
                We built something different. A boutique atelier where every itinerary is signed off by a consultant who has actually stayed at that hotel, tasted that omakase, walked that trail. Our clients don't get "options" — they get a proposal we would take ourselves.
              </p>
              <p>
                Twelve years, 10,000 travellers and 500+ visas later, our commitment hasn't changed. Journey design, done properly.
              </p>
            </div>
          </div>
        </div>
      </section>

      <WhyChoose />
      <Testimonials />
      <CtaBanner onPlanTrip={() => openPlan()} />
    </div>
  );
}
